import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { TextInput, CheckGroup, PeriodTime, Selectize } from '../forms/FormItems';
import { TableFilterPage, ItemHeader } from './PageTemplates';
import { buttonTitles, daysShort } from '../dictionary';
import { stockState } from '../stores/stocks';
import { checkRights, toSelectList, getRequest, toCheckList } from '../functions';

export class StocksPage extends Component {
	constructor(props) {
		super(props);

		stockState.setStock(undefined);

		this.state = {};

		this.getData = this.getData.bind(this);
		this.getData();
		
		var model = this;
		getRequest("Products", { Active : true }, function (data) {
			var products = data.Success ? _.filter(data.Products, function (v) { return v.Type !== 3; }) : [];
			model.setState({ 
				Products : products,
				Sections : _.uniqBy(_.map(products, function(v) { 
					return { Id : v.SectionId, Name : v.Section, Type : v.Type }}), "Id")
			});
		});
	}

	/** API запрос на получение списка всех складов предприятия */
	getData() {
		stockState.IsSendRequest = false;
		getRequest("Stocks", {}, function(data) { stockState.setStocks(data); });
	}

	/**
	 * API запрос на получение одного склада по ID
	 * @param {number} id ID склада
	 */
	getItem(id) {
		getRequest("Stock", { Id : id }, function(data) { stockState.setStock(data.Success ? data : undefined); });
	}

	/**
	 * Выбор/сброс активного склада
	 * @param {number} id ID склада или undefined (сброс)
	 */
	setId(id) { 
		if (!_.isUndefined(id) && id !== -1) this.getItem(id);
		else {
			stockState.setStock(undefined);
			this.getData();
		}
	}

	render() {
		var columns = { Name: {}, Filial: {}, City: {} };
		if (checkRights("ManageStocks")) _.extend(columns, { Edit: {} });

		return (
			<div className="page" id="StocksPage">
				{_.isUndefined(stockState.Stock) && stockState.IsSendRequest &&
					<TableFilterPage 
						Type={this.props.Type}
						CanManage={checkRights("ManageStocks")}
						HideAddButton={true}

						TableData={stockState.Stocks}
						TableColumns={columns}
						TableFilterable={true}

						setId={this.setId.bind(this)}
					/>
				}
				{!_.isUndefined(stockState.Stock) && 
					<StockItem 
						Sections={this.state.Sections}
						Products={this.state.Products}
						setId={this.setId.bind(this)}  
					/>
				}
			</div>
		)
	}
}
StocksPage = observer(StocksPage);

class StockItem extends Component {
	/** API запрос на редактирование настроек склада */
	handleSubmit (event) {
		event.preventDefault();
		
		stockState.ButtonLoading = true;

		getRequest("SaveStock", stockState.getSaveData(), function (data) {
			stockState.ErrorCode = data.Success ? "SUCCESS_SAVE" : data.ErrorCode;
			stockState.SuccessSave = data.Success;
			stockState.ButtonLoading = false;
		});
	}

	/** Закрытие окна редактирования */
	handleClose (event) {
		event.preventDefault();
		this.props.setId(undefined);
	}

	render() {
		return (
			<section className="clearfix item" id="StockItem">
				<form onSubmit={this.handleSubmit.bind(this)} >
					<ItemHeader 
						Title={buttonTitles["EditStock"]}
						Error={stockState.ErrorCode}
						Loading={stockState.ButtonLoading}
						CanManage={checkRights("ManageStocks")}
						Success={stockState.SuccessSave}
						handleClose={this.handleClose.bind(this)}
					/>
					<div className="clearfix main backblock">
						<div className="col col25">
							<TextInput
								Id="Name"
								Title="Склад"
								Value={stockState.Stock.Name}
								Disabled={true}
							/>
						</div>
						<div className="col col25">
							<TextInput
								Id="Filial"
								Title="Филиал"
								Value={stockState.Stock.Filial}
								Disabled={true}
							/>
						</div>
						<div className="col col25">
							<TextInput
								Id="City"
								Title="Город"
								Value={stockState.Stock.City}
								Disabled={true}
							/>
						</div>
					</div>
					<div className="clearfix section" >
						<StockProductsBlock 
							Type="Products"
							key="Products"
							Products={this.props.Products} 
							Sections={this.props.Sections} 
						/>
						<StockProductsBlock 
							Type="Semimanufactures"
							key="Semimanufactures"
							Products={_.filter(this.props.Products, { Type : 2 })} 
							Sections={_.filter(this.props.Sections, { Type : 2 })} 
						/>
					</div>
				</form>
			</section>
		)
	}
}
StockItem = observer(StockItem);

class StockProductsBlock extends Component {
	constructor(props) {
		super(props);

		this.state = { isOpen : true };
	}

	/** Показать/скрыть блок настроек */
	handleToggle (event) {
		event.preventDefault();
		this.setState({ isOpen : !this.state.isOpen });
	}

	/** Добавление раздела ПФ для заготовок */
	handleAdd (event) {
		event.preventDefault();
		stockState.Semimanufactures = _.concat(stockState.Semimanufactures, {
			SectionId : -1, Group : [_.clone(stockState.SemiDummy)] });
	}

	render() {
		var view = this;

		if (this.props.Type === "Products")
			return(
				<div className="clearfix block products">
					<h4>Конфигурация склада
						<a href="/" className={"toggle " + (this.state.isOpen ? "open" : "close")}
							onClick={this.handleToggle.bind(this)}>
								<i></i>{this.state.isOpen ? "Свернуть" : "Развернуть"}</a>
					</h4>
					{this.state.isOpen && _.map(stockState.Products, function (products, type) {
						return(<StockProductType
							key={"t" + type}
							ProductType={type}
							Sections={_.filter(view.props.Sections, { Type : parseInt(type, 10) })}
							Products={_.filter(view.props.Products, { Type : parseInt(type, 10) })}
							ProductsGroup={products}
						/>)
					})}
				</div>
			)
		else 
			return(
				<div className="clearfix block semimanufactures">
					<h4>Ежедневные заготовки
						<a href="/" className={"toggle " + (this.state.isOpen ? "open" : "close")}
							onClick={this.handleToggle.bind(this)}>
								<i></i>{this.state.isOpen ? "Свернуть" : "Развернуть"}</a>
					</h4>
					{this.state.isOpen &&
						<div className="clearfix">
							{_.map(stockState.Semimanufactures, function (group,i) {
								return(<StockProductsGroup key={"sg" + i}
									Type={view.props.Type}
									SectionId={group.SectionId}
									Sections={view.props.Sections}
									Products={view.props.Products}
									Index={i}
									Group={group.Group}
								/>)
							})}
							{checkRights("ManageStocks") &&
								<a href="/" className="icon add button" onClick={this.handleAdd.bind(this)}>
									<i></i>Добавить раздел</a>
							}
						</div>
					}
				</div>
			)
	}
}
StockProductsBlock = observer(StockProductsBlock);

class StockProductType extends Component {
	/** Добавление раздела продуктов (сырье или ПФ) для настроек конфигурации склада */
	handleAdd (event) {
		event.preventDefault();
		stockState.Products[this.props.ProductType] = _.concat(stockState.Products[this.props.ProductType], 
			_.extend(_.clone(stockState.SectionDummy), { Group : [_.clone(stockState.ProductDummy)]}));
	}

	render() {
		var view = this;

		return(
			<div className="clearfix block">
				<h4>{this.props.ProductType === "1" ? "Сырье" : "Полуфабрикаты"}</h4>
				{_.map(this.props.ProductsGroup, function (group,i) {
					return(<StockProductsGroup key={"pg" + i}
						Type="Products"
						SectionId={group.SectionId}
						ProductType={view.props.ProductType}
						Sections={view.props.Sections}
						Products={view.props.Products}
						Index={i}
						Group={group.Group}
					/>)
				})}
				{checkRights("ManageStocks") &&
					<a href="/" className="icon add button" onClick={this.handleAdd.bind(this)}>
						<i></i>Добавить раздел</a>
				}
			</div>
		)
	}
}
StockProductType = observer(StockProductType);

class StockProductsGroup extends Component {
	/** Удаление блока раздела продуктов */
	handleDelete (event) {
		event.preventDefault();

		var index = this.props.Index;
		if (this.props.Type === "Products")
			stockState.Products[this.props.ProductType] = _.filter(stockState.Products[this.props.ProductType], 
				function (v,i) { return i !== index; });
		else
			stockState.Semimanufactures = _.filter(stockState.Semimanufactures, function (v,i) { 
				return i !== index; });
	}

	/**
	 * Сбор данных с формы редактирования склада
	 * @param {string} value значение параметра
	 * @param {string} id название параметра
	 */
	handleChange (value, id) {
		if (this.props.Type === "Products")
			stockState.collectProducts(id, value, undefined, this.props.Index, this.props.ProductType);
		else
			stockState.collectSemi(id, value, undefined, this.props.Index);
	}

	/** Добавление продукта в список */
	handleAdd (event) {
		event.preventDefault();
		
		var index = this.props.Index;
		if (this.props.Type === "Products")
			stockState.Products[this.props.ProductType][index].Group = 
				_.concat(stockState.Products[this.props.ProductType][index].Group, _.clone(stockState.ProductDummy));
		else
			stockState.Semimanufactures[index].Group = _.concat(stockState.Semimanufactures[index].Group, 
				_.clone(stockState.SemiDummy))
	}

	render() {
		var view = this,
			products = _.filter(this.props.Products, { SectionId : this.props.SectionId });

		return(
			<div className="clearfix group">
				<div className="clearfix title">
					<Selectize
						Id="SectionId"
						Title="Раздел"
						List={toSelectList(this.props.Sections)}
						Value={this.props.SectionId}
						RowClass="col col40"
						onChange={this.handleChange.bind(this)}
					/>
					{checkRights("CanManage") &&
						<a href="/" className="icon remove button" onClick={this.handleDelete.bind(this)}>
							<i></i>Удалить раздел</a>
					}
				</div>
				<div className="clearfix">
					{_.map(this.props.Group, function (item, i) {
						if (view.props.Type === "Products")
							return(<StockConfigItem key={"pgs" + i} Item={item} Index={i}
								GroupIndex={view.props.Index} Products={products} 
								ProductType={view.props.ProductType}/>)
						else
							return(<SemimanufacturesItem key={"sgs" + stockState.sCounter++} Item={item} Index={i}
								GroupIndex={view.props.Index} Products={products}/>)
					})}
					{checkRights("ManageStocks") &&
						<a href="/" className="icon add button" onClick={this.handleAdd.bind(this)}>
							<i></i>{"Добавить " + (this.props.ProductType === "1" ? "сырье" : "полуфабрикат")}</a>
					}
				</div>
			</div>
		)
	}
}
StockProductsGroup = observer(StockProductsGroup);

class StockConfigItem extends Component {
	/**
	 * Сбор данных с формы редактирования конфигурации склада
	 * @param {string} value значение параметра
	 * @param {string} id название параметра
	 */
	handleChange (value, id) { 
		var unit = "";
		if (/ProductId/.test(id)) {
			var product = _.find(this.props.Products, { Id : value });
			unit = product ? product.UnitNet : "";
		}

		stockState.collectProducts(id, value, this.props.Index, this.props.GroupIndex, 
			this.props.ProductType, unit); 
	}

	/** Удаление продукта из списка */
	handleDelete (event) {
		event.preventDefault();

		var index = this.props.Index,
			group = this.props.GroupIndex
		stockState.Products[this.props.ProductType][group].Group = 
			_.filter(stockState.Products[this.props.ProductType][group].Group, 
				function (v,i) { return i !== index; });
	}

	render() {
		return(
			<div className="clearfix item">
				<Selectize
					Id="ProductId"
					Title={this.props.ProductType === "1" ? "Сырье" : "Полуфабрикат"}
					Value={this.props.Item.ProductId}
					List={toSelectList(this.props.Products)}
					Disabled={!checkRights("ManageStocks")}
					RowClass="col col40"
					onChange={this.handleChange.bind(this)}
				/>
				<TextInput
					Id="UnitName"
					Title="ЕИ"
					Value={this.props.Item.UnitName}
					RowClass="col col5"
					Disabled={true}
				/>
				<TextInput
					Id="Count"
					Value={this.props.Item.Count}
					Type="number"
					Step="0.01"
					Title="Мин. кол-во"
					RowClass="col col10"
					Disabled={!checkRights("ManageStocks")}
					Required={true}
					onChange={this.handleChange.bind(this)}
				/>
				<CheckGroup
					Id="Revision"
					Type="checkbox"
					List={[{ Id : "true", Title : "Участвует в ревизии"}]}
					Value={this.props.Item.Revision ? ["true"] : []}
					RowClass="col col15"
					Disabled={!checkRights("ManageStocks")}
					onChange={this.handleChange.bind(this)}
				/>
				{this.props.ProductType === "2" &&
					<CheckGroup
						Id="NotRelease"
						Type="checkbox"
						List={[{ Id : "true", Title : "Не производится на складе"}]}
						Value={this.props.Item.NotRelease ? ["true"] : []}
						RowClass="col col25"
						Disabled={!checkRights("ManageStocks")}
						onChange={this.handleChange.bind(this)}
					/>
				}
				{checkRights("ManageStocks") &&
					<a href="/" className="button icon remove" onClick={this.handleDelete.bind(this)}><i></i></a>
				}
			</div>
		)
	}
}
StockConfigItem = observer(StockConfigItem);

class SemimanufacturesItem extends Component {
	/**
	 * Сбор данных с формы редактирования заготовок склада
	 * @param {string} value значение параметра
	 * @param {string} id название параметра
	 */
	handleChange (value, id) { 
		var product = {}
		if (/ProductId/.test(id)) product = _.find(this.props.Products, { Id : value });

		stockState.collectSemi(id, value, this.props.Index, this.props.GroupIndex, product); 
	}

	/** Удаление продукта из списка */
	handleDelete (event) {
		event.preventDefault();
		var index = this.props.Index,
			group = this.props.GroupIndex;

		stockState.Semimanufactures[group].Group = _.filter(stockState.Semimanufactures[group].Group, 
			function (v,i) { return i !== index; });
	}

	render() {
		var days = _.map(daysShort, function (v, i) { return { Id : i, Name : v }});
		
		return(
			<div className="clearfix item">
				<Selectize
					Id="ProductId"
					Title="Полуфабрикат"
					List={toSelectList(this.props.Products)}
					Value={this.props.Item.ProductId}
					RowClass="col col25"
					onChange={this.handleChange.bind(this)}
				/>
				<TextInput
					Id="Count"
					Title="Кол-во"
					Value={this.props.Item.Count}
					RowClass="col col10"
					Required={true}
					onChange={this.handleChange.bind(this)}
				/>
				<TextInput
					Id="UnitName"
					Title="ЕИ"
					Value={this.props.Item.UnitName}
					RowClass="col col5"
					Disabled={true}
				/>
				<PeriodTime
					Id="Time"
					Title="Время выполнения"
					RowClass="col col25"
					Value={{ StartTime : this.props.Item.StartTime, EndTime : this.props.Item.EndTime }}
					onChange={this.handleChange.bind(this)}
				/>
				<CheckGroup
					Id="Day"
					Title=""
					Type="checkbox"
					RowClass="col col35 days"
					List={toCheckList(days)}
					Value={this.props.Item.Day}
					onChange={this.handleChange.bind(this)}
				/>
				{checkRights("ManageStocks") && <a href="/" className="icon remove button" 
					onClick={this.handleDelete.bind(this)}><i></i></a>
				}
			</div>
		)
	}
}
SemimanufacturesItem = observer(SemimanufacturesItem);
